import { useSelector } from "react-redux";

const userRoleOf = (state) => state.userReducer.user?.attributes?.userRole;

/**
 * A store's commercial (userRole 7) never sees the store's purchase prices,
 * order amounts or margins — only public TTC prices (the API strips the rest
 * too). Every price display of the catalogue, the order funnel, Commandes and
 * Espace clients reads this.
 */
const useCanSeePrices = () => useSelector(userRoleOf) !== 7;

/**
 * Nor does it order (the store does): no cart, no add-to-cart, no « Passer la
 * commande » — the API refuses those routes to it anyway.
 */
export const useCanOrder = () => useSelector(userRoleOf) !== 7;

export default useCanSeePrices;
